/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import React, { forwardRef } from 'react';

import 'moment/locale/pt-br';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { useAuth } from '../../../hooks/auth';
import BRLMoneyFormat from '../../../utils/BRLMoneyFormat';

import stylesMaterial from './stylesMaterial';
import { Container, Complemento, TotalItem, Produto } from './styles';
import { IIfoodOrder } from '../../../interfaces/IIfoodOrder';
import { getPaymentMethod } from '../MainContainer/ContentIfood';

interface ComponentToPrintProps {
  ifoodOrder: IIfoodOrder;
}

const ComponentToPrintIfood = forwardRef<HTMLDivElement, ComponentToPrintProps>(
  (props, ref) => {
    const classes = stylesMaterial();
    const { ifoodOrder } = props;

    const { user } = useAuth();
    const moment = require('moment');

    return (
      <Container ref={ref}>
        <Typography className={classes.empresa}>
          {user.empresa_nome_fantasia}
        </Typography>

        <Typography className={classes.texto}>
          {`Funcionário: ${user.nome}`}
        </Typography>

        <Typography className={classes.texto}>
          Emissão: {moment(new Date(ifoodOrder.createdAt)).format('LT | L')}
        </Typography>

        <Typography className={classes.texto}>
          {`Pedido: ${ifoodOrder.displayId}`}
        </Typography>

        {ifoodOrder.orderType === 'DELIVERY' && (
          <Typography className={classes.texto}>
            {`Código de Coleta: ${ifoodOrder.delivery?.pickupCode}`}
          </Typography>
        )}

        {ifoodOrder.schedule && (
          <>
            <Divider className={classes.divider} />
            <Typography className={classes.texto}>
              {`Entrega programada para: ${moment(
                new Date(ifoodOrder.schedule.deliveryDateTimeStart),
              ).format('LT | L')}`}
            </Typography>
            <Divider className={classes.divider} />
          </>
        )}

        <Typography className={classes.tituloProdutos}>Produtos</Typography>

        <Divider className={classes.divider} />

        {ifoodOrder.items.map((item) => {
          return (
            <React.Fragment key={item._id}>
              <Produto>
                <Typography className={classes.productText}>
                  {`${Number(item.quantity)}. `}
                  <p>{item.name}</p>
                  <p>
                    ({Number(item.price).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )})
                  </p>
                </Typography>

                <Typography
                  className={classes.productText}
                  style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                >
                  R${' '}
                  {Number(item.totalPrice).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )}
                </Typography>
              </Produto>

              {item.options.map((complemento) => {
                return (
                  <Complemento key={complemento.id}>
                    <Typography className={classes.nomeComplemento}>
                      <>
                        {Number(complemento.quantity)} {complemento.name}
                      </>
                    </Typography>
                    <Typography
                      className={classes.precoComplemento}
                      style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                    >
                      R${' '}
                      {complemento.price.toLocaleString(
                        'pt-BR',
                        BRLMoneyFormat,
                      )}
                    </Typography>
                  </Complemento>
                );
              })}
              {!!item.observations && (
                <Typography className={classes.texto}>
                  Obs: {item.observations}
                </Typography>
              )}
              <TotalItem>
                <Typography className={classes.texto}>Total:</Typography>
                <Typography
                  className={classes.totalItem}
                  style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                >
                  {Number(item.totalPrice).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )}
                </Typography>
              </TotalItem>
            </React.Fragment>
          );
        })}

        <Divider className={classes.divider} />

        <Typography className={classes.clienteInfo}>
          Cliente: {ifoodOrder.customer.name ?? 'Venda balcão'}
        </Typography>

        {ifoodOrder.orderType === 'DELIVERY' ? (
          <Typography className={classes.clienteInfo}>
            Endereço:
            <br />
            {`${ifoodOrder.delivery.deliveryAddress.streetName}, ${ifoodOrder.delivery.deliveryAddress.streetNumber}, ${ifoodOrder.delivery.deliveryAddress.neighborhood}`}
            <br />
            {`${ifoodOrder.delivery.deliveryAddress.city}, ${ifoodOrder.delivery.deliveryAddress.state}, ${ifoodOrder.delivery.deliveryAddress.postalCode}`}
            <br />
            Complemento:
            <br />
            {`${ifoodOrder.delivery.deliveryAddress.complement}`}
          </Typography>
        ) : (
          <Typography className={classes.clienteInfo}>
            Entrega: Retirada balcão
          </Typography>
        )}

        {ifoodOrder.customer?.phone?.number && (
          <Typography className={classes.clienteInfo}>
            Telefone: {ifoodOrder.customer.phone.number}
          </Typography>
        )}

        {ifoodOrder.customer?.phone?.localizer && (
          <Typography className={classes.clienteInfo}>
            Ifood ID: {ifoodOrder.customer.phone.localizer}
          </Typography>
        )}

        {!!ifoodOrder.delivery?.observations && (
          <>
            <Divider className={classes.divider} />

            <Typography className={classes.clienteInfo}>
              Observação: <br />
              {ifoodOrder.delivery.observations}
            </Typography>
          </>
        )}

        <Divider className={classes.divider} />

        <Typography className={classes.texto}>
          Forma de Pagamento:
        </Typography>

        {ifoodOrder.payments.methods.map(method => (
          <Typography key={method._id} className={classes.texto}>
            {`
              ${getPaymentMethod(method.method)}
               - 
              ${method.method === 'CREDIT' ? (
                `${method.card.brand}`
              ) : (
                `${method.prepaid ? 'Pago' : 'Pendente'}`
              )}
               - 
              ${method.value.toLocaleString(
                'pt-BR',
                BRLMoneyFormat,
              )}`
            }
          </Typography>
        ))}

        <Typography className={classes.texto}>
          Subtotal:{' '}
          {ifoodOrder.total.subTotal.toLocaleString(
            'pt-BR',
            BRLMoneyFormat,
          ) || ''}
        </Typography>

        {ifoodOrder.total.deliveryFee ? (
          <Typography className={classes.texto}>
            Taxa de entrega:{' '}
            {ifoodOrder.total.deliveryFee.toLocaleString('pt-BR', BRLMoneyFormat) ||
              ''}
          </Typography>
        ) : null}

        {ifoodOrder.total.benefits > 0 && (
          <Typography className={classes.texto}>
            Desconto:{' '}
            {ifoodOrder.total.benefits.toLocaleString(
              'pt-BR',
              BRLMoneyFormat,
            )}
          </Typography>
        )}
        {ifoodOrder.total.additionalFees > 0 && (
          <Typography className={classes.texto}>
            Custos adicionais:{' '}
            {ifoodOrder.total.additionalFees.toLocaleString(
              'pt-BR',
              BRLMoneyFormat,
            )}
          </Typography>
        )}

        {/* {pedido.discountCouponValue && +pedido.discountCouponValue ? (
          <Typography className={classes.texto}>
            Cupom desconto: R${' '}
            {(+pedido.discountCouponValue * -1).toLocaleString(
              'pt-BR',
              BRLMoneyFormat,
            ) || ''}
          </Typography>
        ) : (
          <div />
        )} */}

        {ifoodOrder.benefits && ifoodOrder.benefits.length > 0 && (
          <Typography className={classes.texto}>
            Promoções:{' '}
            {(ifoodOrder.benefits.reduce((acc, curr) => acc + curr.value, 0) * -1
            ).toLocaleString('pt-BR', BRLMoneyFormat)}
          </Typography>
        )}

        <Typography className={classes.texto}>
          Total:{' '}
          {ifoodOrder.total.orderAmount.toLocaleString('pt-BR', BRLMoneyFormat)}
        </Typography>

        {
          !!ifoodOrder.payments.methods.find((method) => method.method === 'CASH') && 
          !!ifoodOrder.payments.methods.find((method) => method.method === 'CASH')?.cash.changeFor && (
            <Typography className={classes.texto}>
              Troco:{' '}
              {(
                  Number(ifoodOrder.payments.methods.find((method) => method.method === 'CASH')?.cash.changeFor || 0) -
                  (ifoodOrder.payments.methods.find((method) => method.method === 'CASH')?.value || 0)
                ).toLocaleString(
                'pt-BR',
                BRLMoneyFormat,
              )}
            </Typography>
          )
        }

        <Divider className={classes.divider} />
      </Container>
    );
  },
);

export default ComponentToPrintIfood;
